export enum BandwidthPhoneTypeEnum {
  geographic = 'GEOGRAPHIC',
  national = 'NATIONAL',
  mobile = 'MOBILE',
  tollFree = 'TOLL_FREE',
  sharedCost = 'SHARED_COST',
}
